export default "__VITE_ASSET__woBGPLwD__"